import React, { CSSProperties, FC, ReactNode } from 'react';
import { useTheme } from '../../../hooks/useTheme';
import styles from './Paragraph.module.css';

export interface ParagraphProps {
  containerCustomStyle?: CSSProperties;
  children?: ReactNode;
  disableTheme?: boolean;
  id?: string;
}

const Paragraph: FC<ParagraphProps> = ({
  containerCustomStyle,
  children,
  disableTheme,
  id,
}) => {
  const { bodytextDefaultNone } = useTheme();

  const ignoreTheme = disableTheme && containerCustomStyle;
  const style = ignoreTheme
    ? containerCustomStyle
    : {
        ...containerCustomStyle,
        ...bodytextDefaultNone,
      };

  return (
    children && (
      <p id={id} className={styles.paragraph} style={style}>
        {children}
      </p>
    )
  );
};

export default Paragraph;
